import React, { useEffect, useState, useRef } from "react";
import { Tooltip } from "react-tippy";
import { isMobile } from "helpers/Mobile";
import Tag from "components/MainApp/organisms/OrdersV3/Tag";
import default_image from "../../../../../../assets/images/default_product.png";
import styles from "./ItemStock.module.scss";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center"
};
const ItemStock = ({
  stock,
  list,
  tagsInMov = [],
  originalStock,
  collectAuditDetails,
  isLastItem
}) => {
  const [row, setRow] = useState({});
  const [opened, setOpened] = useState(false);
  const [auditDetails, setAuditDetails] = useState([]);
  const prevAuditDetails = useRef([]);
  const columns = ["title", "sku", "tags"];

  useEffect(() => {
    if (!stock || !stock.tags) return;

    const newRow = {
      ...stock,
      tags: `${stock.readItems} / ${stock.expectedUnits}`
    };
    setRow(newRow);

    const initialAuditDetails = [];

    // Create or update the audit details with the tags.
    stock.tags.forEach(tag => {
      const matchingStock = originalStock.find(
        stockItem => stockItem.tag.rfid === tag.tag
      );

      if (matchingStock) {
        const newDetail = {
          rfid: tag.tag,
          product_id: matchingStock.item.id,
          found_status: tag.selected,
          modified_status: false,
          location: matchingStock.location.id
        };

        // If a detail with the same RFID already exists, update the corresponding data.
        const existingDetailIndex = initialAuditDetails.findIndex(
          detail => detail.rfid === tag.tag
        );

        if (existingDetailIndex !== -1) {
          // Update existing detail
          initialAuditDetails[existingDetailIndex] = {
            ...initialAuditDetails[existingDetailIndex],
            ...newDetail
          };
        } else {
          // If it doesn't exist, add it to the array
          initialAuditDetails.push(newDetail);
        }
      }
    });

    // Update only if the audit details have changed
    if (
      initialAuditDetails.length > 0 &&
      !arraysAreEqual(prevAuditDetails.current, initialAuditDetails)
    ) {
      setAuditDetails(initialAuditDetails);
      // Update the reference status
      prevAuditDetails.current = initialAuditDetails;
      collectAuditDetails(initialAuditDetails);
    }
  }, [stock, originalStock, collectAuditDetails]);

  const updateFoundStatus = tag => {
    setAuditDetails(prevDetails => {
      const newDetails = prevDetails.map(detail =>
        detail.rfid === tag.tag ? { ...detail, found_status: !!tag.selected } : detail
      );
      collectAuditDetails(newDetails);
      return newDetails;
    });
  };

  const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (
        arr1[i].rfid !== arr2[i].rfid ||
        arr1[i].found_status !== arr2[i].found_status
      ) {
        return false;
      }
    }
    return true;
  };

  const handleClick = () => {
    const openedAux = opened;
    setOpened(!openedAux);
  };

  const renderColumn = key => {
    return (
      <div
        className={`${styles[`reading-table-item-${key}`]} ${
          styles["reading-table-item"]
        }`}
        data-stock-id={key}
        onClick={handleClick}
        key={key}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {key === "tags"
                ? `${stock.readItems} / ${stock.expectedUnits}`
                : stock[key]}
            </div>
          }
          followCursor={true}
          position="left"
          offset={25}
        >
          <p className={styles["container_icons"]}>
            {key === "title" && (
              <img src={stock?.image ? [stock.image] : [default_image]} />
            )}
            {key === "tags"
              ? `${stock.readItems} / ${stock.expectedUnits}`
              : stock[key]}
            {key === "tags" &&
              (stock.expectedUnits === 0 ? (
                <span
                  className={styles["icons"] + " " + styles["question_blue"]}
                >
                  ?
                </span>
              ) : stock.readItems === stock.expectedUnits ? (
                <i
                  className={` ${styles["icons"]}  ${styles["icon-check"]} icon-check`}
                ></i>
              ) : stock.readItems < stock.expectedUnits &&
                stock.readItems >= 1 ? (
                <i
                  className={` ${styles["icons"]}  ${styles["icon-iconos_menos"]} icon-iconos_menos `}
                ></i>
              ) : (
                <i
                  className={` ${styles["icons"]} icon-cruz ${styles["icon-cruz"]}`}
                ></i>
              ))}
          </p>
        </Tooltip>
      </div>
    );
  };

  return (
    <div
        className={`${styles["reading-table-item-wrapper"]} ${
          isLastItem ? styles["last-item-fix"] : "" 
        }`}
        data-automation-id="stock-item-wrapper"
      >
      {!isMobile && (
        <div
          className={styles["reading-table-item-container"]}
          data-automation-id="stock-item"
        >
          {columns.map(column_key => {
            return renderColumn(column_key);
          })}

          <div
            className={
              styles["reading-table-item-button"] +
              (opened ? " " + styles["opened"] : "")
            }
            data-automation-id="select-stock"
            data-stock-id={stock.sku}
            onClick={handleClick}
            key={"button"}
          >
            <i className="icon-chevron"></i>
          </div>
        </div>
      )}
      {isMobile && (
        <div className={styles["reading-table-item-mobile-container"]}>
          <div
            className={styles["reading-table-item-row"]}
            onClick={handleClick}
          >
            <div
              className={
                styles["reading-table-item-column"] + " " + styles["image"]
              }
            >
              <div>
                <img src={stock?.image ? [stock.image] : [default_image]} />
              </div>
            </div>
            <div
              className={
                styles["reading-table-item-column"] + " " + styles["title"]
              }
            >
              <h1>{stock.title}</h1>
              <p>SKU {stock.sku}</p>
            </div>
            {stock.expectedUnits === 0 ? (
              <span className={styles["icons"] + " " + styles["question_blue"]}>
                ?
              </span>
            ) : stock.readItems === stock.expectedUnits ? (
              <i
                className={` ${styles["icons"]} ${styles["icon-check"]} icon-check`}
              ></i>
            ) : stock.readItems < stock.expectedUnits &&
              stock.readItems >= 1 ? (
              <i
                className={` icon-iconos_menos ${styles["icons"]} ${styles["icon-iconos_menos"]} `}
              ></i>
            ) : (
              <i
                className={` ${styles["icons"]} ${styles["icon-cruz"]} icon-cruz `}
              ></i>
            )}
            <div
              className={
                styles["reading-table-item-column"] + " " + styles["button"]
              }
            >
              <div
                className={
                  styles["reading-table-item-button"] +
                  (opened ? " " + styles["opened"] : "")
                }
                data-automation-id="select-stock"
                data-stock-id={stock.sku}
                key={"button"}
              >
                <i className={styles["icon-chevron"]}></i>
              </div>
            </div>
          </div>
          <div
            className={styles["reading-table-item-row"] + " " + styles["tags"]}
          >
            <p>
              Tags <span>{stock.readItems}</span>/{stock.expectedUnits}
            </p>
          </div>
        </div>
      )}

      <div
        className={
          styles["reading-table-list"] + (opened ? " " + styles["opened"] : "")
        }
      >
        <div className={styles["reading-table-tags-separator"]}></div>
        {list.map(tag => {
          return (
            <Tag
              tag={tag}
              epc={tag.epc}
              type="verification"
              selected={tag.selected}
              message={tag.message}
              key={tag.tag}
              tagsInMov={tagsInMov}
              handleUpdateFoundStatus={updateFoundStatus}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ItemStock;
